export const PHONE_VALIDATION_REGEX = /^\+?\d{1,3}?[- ]?\(?(?:\d{2,3})\)?[- ]?\d\d\d[- ]?\d\d\d\d$/;